<!-- Component Wrapper -->
<div class="account-selector-card">

  <!-- LCPtracker Logo Container -->
  <div class="text-center">

    <!-- LCPtracker Logo -->
    <img src="assets/logo.png" alt="LCPtracker Logo">

  </div>


  <section class="selector-database" >

    <div class="selector-database-title">
      <h4>Account Selection</h4>
      <p>Select the accounts associated to your contractor license to associate with your new user account</p>
    </div>
    <div>
      <cdk-virtual-scroll-viewport itemSize="15" class="virtual-scroll-container">
        <mat-progress-bar *ngIf="(loadingSubject$ | async)" mode="indeterminate" value="40"></mat-progress-bar>
        <table aria-describedby="table body" class="table-content">
          <thead>
            <tr>
              <th class="mat-header-cell mat-header-lcp-cell text-center">
                <mat-checkbox [disabled]="(loadingSendInformationSubject$ | async) || (loadingSubject$ | async)" (change)="$event ? toggleAllRows() : null"
                  [checked]="rowsSelection.hasValue() && isAllSelected()"
                  [indeterminate]="rowsSelection.hasValue() && !isAllSelected()" [aria-label]="checkboxColumnTitle()">
                </mat-checkbox>
              </th>
              <th class="mat-header-cell mat-header-lcp-cell text-center">Code</th>
              <th class="mat-header-cell mat-header-lcp-cell">Account Name</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *cdkVirtualFor="let row of itemsDataSource">
              <tr>
                <td class="w-28 text-center">
                  <mat-checkbox [disabled]="(loadingSendInformationSubject$ | async) || (loadingSubject$ | async)" onkeypress="javascript:void(0)" (click)="$event.stopPropagation()"
                    (change)="$event ? rowsSelection.toggle(row) : null" [checked]="rowsSelection.isSelected(row)"
                    [aria-label]="checkboxColumnTitle(row)">
                  </mat-checkbox>
                </td>
                <td class="w-48 text-center">{{ row.OrgCode }}</td>
                <td class="w-9/12 cell-wrap">{{ row.Name }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
    </div>

    <div class="legal-labels">
      <mat-checkbox [disabled]="(loadingSendInformationSubject$ | async) || (loadingSubject$ | async)" [(ngModel)]="checkboxLegalAgreements" (change)="acceptLegalAgreementsChange()">
        <p class="checkbox-legal">
          I confirm the checked accounts above are those to which I am entitled to access
        </p>
      </mat-checkbox>
    </div>

    <!-- Full Contractor Onboarding Form Buttons -->
    <div class="action-buttons">

      <!-- Cancel Button -->
      <app-button
        buttonType="flat"
        label="Cancel"
        (buttonClicked)="cancelAccountSelection()"
      ></app-button>

      <!-- Confirm Button -->
      <app-button
        buttonType="primary"
        label="Confirm"
        [isDisabled]="isCountButtonToConfirm"
        (buttonClicked)="confirmSelectionToSendDB()"
      ></app-button>

    </div>

  </section>
</div>
